export function parseNumericStr(str) {
  const isNumericStr = Number.isInteger(Number(str));

  if (isNumericStr) {
    return parseInt(str);
  } else {
    return str;
  }
}
